import { PipelineStepType, SelectOption } from './pipelineBuilder.types'
import { TransitionExitMode } from './transitionConfig.types'
import { LEAD_CONVERSION_TRIGGER_OPTIONS } from './stepConfig.types'
import { STEP_CATALOG } from './stepCatalog'
import { DEFAULT_LEADS_EXIT_TRIGGERS } from './exitFromLeadsUtils'

export const PM_MANUAL_TRIGGER = 'pm_manual'

const PM_MANUAL_OPTION: SelectOption = {
    value: PM_MANUAL_TRIGGER,
    label: 'PM manually advances',
}

export const LEADS_EXIT_TRIGGER_OPTIONS: SelectOption[] = [
    {
        value: 'account_created',
        label: 'Applicant account created',
    },
    {
        value: 'identity_complete',
        label: 'Identity phase complete',
    },
    {
        value: 'workbook_complete',
        label: 'Application workbook complete',
    },
    {
        value: 'qualifying_worksheet_complete',
        label: 'Qualifying worksheet complete (legacy)',
    },
]

/** Trigger options available when leaving `fromType` for the next step. */
export function getTransitionTriggerOptions(
    fromType: PipelineStepType,
): SelectOption[] {
    if (fromType === 'prospects') {
        return LEAD_CONVERSION_TRIGGER_OPTIONS.map((option) => ({
            value: option.value,
            label: option.label,
        }))
    }

    if (fromType === 'leads') {
        return LEADS_EXIT_TRIGGER_OPTIONS.map((option) => ({ ...option }))
    }

    const catalog = STEP_CATALOG[fromType]
    const options: SelectOption[] = catalog.completionOptions
        .filter(
            (option) =>
                option.value !== 'pm_advances' &&
                option.value !== 'pm_marks_complete',
        )
        .map((option) => ({
            value: option.value,
            label: option.label,
        }))

    if (!options.some((option) => option.value === PM_MANUAL_TRIGGER)) {
        options.push(PM_MANUAL_OPTION)
    }

    return options
}

export function defaultExitModeForFromType(
    fromType: PipelineStepType,
): TransitionExitMode {
    if (fromType === 'prospects') {
        return 'conversion'
    }
    if (fromType === 'leads') {
        return 'all'
    }
    return 'any'
}

export function defaultTriggersForStep(fromType: PipelineStepType): string[] {
    if (fromType === 'prospects') {
        return getTransitionTriggerOptions(fromType).map(
            (option) => option.value,
        )
    }

    if (fromType === 'leads') {
        return [...DEFAULT_LEADS_EXIT_TRIGGERS]
    }

    const options = getTransitionTriggerOptions(fromType)
    const catalog = STEP_CATALOG[fromType]
    const defaults = new Set<string>([catalog.defaultCompletion.condition])
    if (options.some((option) => option.value === PM_MANUAL_TRIGGER)) {
        defaults.add(PM_MANUAL_TRIGGER)
    }
    return Array.from(defaults)
}

export function labelForTrigger(
    fromType: PipelineStepType,
    trigger: string,
): string {
    const option = getTransitionTriggerOptions(fromType).find(
        (item) => item.value === trigger,
    )
    if (option) {
        return option.label
    }
    if (trigger === PM_MANUAL_TRIGGER) {
        return PM_MANUAL_OPTION.label
    }
    return trigger
}
